export default {
  props: {
    hideLinks: false,
    tourUrl: 'https://www.sibcycline.com'
  }
};
